/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Link_Expired_BodyInputs */

const en_password_reset_link_expired_body = /** @type {(inputs: Password_Reset_Link_Expired_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset links work once and expire after 1 hour. Request a new one to continue.`)
};

const es_password_reset_link_expired_body = /** @type {(inputs: Password_Reset_Link_Expired_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los enlaces de restablecimiento funcionan una sola vez y caducan en 1 hora. Solicita uno nuevo para continuar.`)
};

/**
* | output |
* | --- |
* | "Reset links work once and expire after 1 hour. Request a new one to continue." |
*
* @param {Password_Reset_Link_Expired_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_link_expired_body = /** @type {((inputs?: Password_Reset_Link_Expired_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Link_Expired_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_link_expired_body(inputs)
	return en_password_reset_link_expired_body(inputs)
});